var IncrementalDOM = require('incremental-dom')
var patch = IncrementalDOM.patch
var elementOpen = IncrementalDOM.elementOpen
var elementClose = IncrementalDOM.elementClose
var skip = IncrementalDOM.skip
var currentElement = IncrementalDOM.currentElement
var text = IncrementalDOM.text

var __target

module.exports = function description (type, def, root) {
  var defView
  if (type === 'String') {
    defView = require('./defs/string.html')
          defView(def, root)
  } else if (type === 'Number') {
    defView = require('./defs/number.html')
          defView(def, root)
  } else if (type === 'Boolean') {
    defView = require('./defs/boolean.html')
          defView(def, root)
  } else if (type === 'Date') {
    defView = require('./defs/date.html')
          defView(def, root)
  } else if (type === 'Mixed') {
    defView = require('./defs/mixed.html')
          defView(def, root)
  } else if (type === 'ObjectId') {
    defView = require('./defs/objectid.html')
          defView(def, root)
  } else if (type === 'Array') {
    defView = require('./defs/array.html')
          defView(def, root)
  } else if (type === 'NestedDocument') {
    defView = require('./defs/nesteddocument.html')
          defView(def, root)
  } else if (type === 'ForeignKey') {
    defView = require('./defs/foreignkey.html')
          defView(def, root)
  } else if (type === 'ChildDocument') {
    defView = require('./defs/childdocument.html')
          defView(def, root)
  } else if (type === 'Buffer') {
    defView = require('./defs/buffer.html')
          defView(def, root)
  }
}
